export class SharedConstants {
    static GLOBAL_ERROR_MESSAGE = "Something went wrong. Please try again or contact your system administrator.";
    // Labels for Buttons
    static ADD_LABEL = "Add";
    static EDIT_LABEL = "Edit";
    static DELETE_LABEL = "Delete";
    static REMOVE_LABEL = "Delete";
    static SAVE_LABEL = "Save";
    static CANCEL_LABEL = "Cancel";
    static UPDATE_LABEL = "Update";
    static CREATE_LABEL = "Create";
    static SUSPEND_LABEL = "Suspend";
    static REINSTATE_LABEL = "Reinstate";
    static YES_LABEL = "Yes";
    static NO_LABEL = "No";
    static CLEAR_LABEL = "Clear";
    static CLOSE_LABEL = "Close";
    static SELECT_LABEL = "Select";
    static SEND_LABEL = "Send";
    static REFRESH_LABEL = "Refresh";
    static OK_LABEL = "Ok";
    static SUBMIT_LABEL = "Submit";
    /* headings */
    static HELP_INFO_TEXT = "Show help / further information";
    /* Forms */
    // Messages for Form Validation
    static INVALID_METADATA = "Invalid metadata, please contact the system administrator";
    static FORM_NOT_VALID = "Please complete all fields to continue"; // Use as Alert warning when trying to update/save form
    static FILE_CONTROL_DEFAULT = "Please upload a file";
    static PHONE_NUMBER_VALIDATION_MESSAGE = "Please enter a valid phone number in the format +27123457788.";
    static EMAIL_VALIDATION_MESSAGE = "Please enter a valid email address, for example, JDoe@gmail.com.";
    static REQUIRED_INPUT_CONTROL_VALIDATION = "is required.";
    static NUMERIC_INPUT_CONTROL_VALIDATION = "must be a number.";
    static DATE_INPUT_CONTROL_VALIDATION = "Please select a valid date";
    static DECIMAL_INPUT_CONTROL_VALIDATION = "must be a decimal number.";
    static INVALID_INPUT_CONTROL_VALIDATION = "is not valid.";
    static MINIMUM_NUMERIC_INPUT_CONTROL_VALIDATION = "must be a number not less than";
    static UNIQUE_INPUT_CONTROL_VALIDATION = "must be unique.";
    static MAX_LENGTH_INPUT_CONTROL_VALIDATION = "must have no more than yyy characters.";
    static USED_VALUE_INPUT_CONTROL_VALIDATION = "already in use. Please supply new yyy.";
    static EMAIL_NOT_SENT = "Please send the email before continuing to the next step";
    static CONTINUE_CREATE_APPLICATION = "All data saved successfully. Please create the application";
    static FORM_DATA_CLEARED = "Data cleared";
    static FORM_DATA_SAVED = "Current form data saved";
    static BOOKMARK_SAVED = "Bookmark saved";
    // Patterns
    static PHONE_VALIDATOR_PATTERN = new RegExp(/^((?:\+|0)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))$/);
    static URL_VALIDATOR_PATTERN = new RegExp("(https://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?");
    static DECIMAL_VALIDATOR_PATERN = new RegExp(/^\d*(\.\d{2})$/);
    // Message & Title when removing an item from a list
    static REMOVE_TITLE = "Delete "; // add to title e.g. REMOVE_TITLE + "template(s)"
    static REASSIGN_TITLE = "Reassign "; // add to title e.g. REMOVE_TITLE + "step(s)"
    static REMOVE_MESSAGE = "Are you sure you want to delete the selected"; // add to message e.g. REMOVE_MESSAGE + "template(s)"
    static SUSPEND_MESSAGE = "Are you sure you want to suspend the selected"; // add to message e.g. SUSPEND_MESSAGE + "user"
    static UNSUSPEND_MESSAGE = "Are you sure you want to reinstate the selected "; // add to message e.g. UNSUSPEND_MESSAGE + "user"
    static REASSIGN_MESSAGE = "Are you sure you want to reassign "; // add to message e.g. REASSIGN_MESSAGE + "step"
    // Alert Messages
    static ADD_SUCCESS = "Item added successfully.";
    static ADD_FAILED = "Adding of item failed.";
    static UPDATE_SUCCESS = "Item updated successfully.";
    static UPLOAD_SUCCESS = "Item uploaded successfully.";
    static UPDATE_FAILED = "Updating of item failed.";
    static REMOVE_SUCCESS = "Item deleted successfully.";
    static REMOVE_FAILED = "Deleting of item failed.";
    static SUSPEND_SUCCESS = "Suspended successfully.";
    static SUSPEND_FAILED = "Suspending failed.";
    static REINSTATE_SUCCESS = "Reinstatement successful.";
    static ITEM_NOT_SUSPENDED_LABEL = "is not suspended."; // If you try to unsuspend item that is not suspended
    static ITEM_ALREADY_SUSPENDED_LABEL = "is already suspended."; // If you try to suspend item that is already suspended
    static ITEM_SUSPENDED = "is suspended.";
    static SUBMIT_SUCCESS = "Feedback submitted successfully.";
    static APPLICATION_CREATED_PART1;
    static APPLICATION_CREATED_PART2;
    static CLIPBOARD_MESSAGE = "Item was copied to clipboard"; // used to signify if text is copied to clipboard in-app
    static CLIPBOARD_NO_DATA = "No data to copy to clipboard";
    static BAD_REQUEST_MESSAGE = "Invalid data provided for operation";
    static EXPORT_NO_DATA_MESSAGE = "No data to export";
    static FORBIDDEN_MESSAGE = "You are not allowed to access this resource. Please contact your system administrator.";
    static NOT_FOUND_MESSAGE = "Data not found";
    static UNKNOWN_ERROR_MESSAGE = "Unknown server error with";
    static UNKNOWN_MODULE_ERROR_MESSAGE = "Module has not been configured correctly. Please contact your system administrator";
    static NO_ITEMS_AVAILABLE_MESSAGE = "There are no items to display";
    static NO_FILTER_SELECTED_MESSAGE = "Please select a filter option";
    static NO_SEARCH_TEXT_ENTERED_MESSAGE = "Please enter text to filter search";
    static NO_SEARCH_SELECTED_MESSAGE = "Please select a search option";
    // Warning messages for either too many or too few items selected OR not step selected from a drop down
    static NO_OPTION_SELECTED = "Please select an option"; // Used if a dropdown item must be selected
    static NO_ITEM_SELECTED = "Please select an item from the list"; // Used if no item selected from a table
    static MORE_THAN_ONE_SELECTED = "Only one item may be edited at a time"; // Used if only 1 item should be selected
    static INSUFFICIENT_PERMISSIONS = "You do not have sufficient permissions to perform this operation. Please contact your system administrator";
    static MISSING_METADATA = "No metadata for the step. Please contact your system administrator.";
    static STEP_CONTINUE_FALSE = "Not allowed to continue.";
    /* Search Filter */
    static SEARCH_NOT_BLANK = "Search criteria may not be blank";
    // Filter labels
    static FILTER_BY_DEFAULT = "All columns";
    static FILTER_BY_PLACEHOLDER = "Filter by none";
    static FILTER_ITEMS_PLACEHOLDER = "Filter items";
    static FILTER_PREFIX = "Filter by";
    static SEARCH_PREFIX = "Search"; // Placeholder on table search
    static FILTER_DEFAULT = "All"; // used on recipients select and recipients list filters
    static DASHBOARD_FILTERS = {
        LatestApplications: "LatestApplications",
        OverdueApplications: "OverdueApplications",
        ApplicationStatus: "status"
    };
    static OPTION_CHECKBOX_ID = "optionCheckboxId";
    // Attachment type restricted names
    static ATTACHMENT_TYPE = [
        "proof of payments",
        "invoices",
        "proof of payment",
        "invoice"
    ];
    // Search Types and Maps
    static SEARCH_BY_DEFAULT = "Please select";
    static MAP_TEXT = "Map";
    static ENLARGE_MAP_TEXT = "Enlarge Map";
    static SHRINK_MAP_TEXT = "Shrink Map";
    static ADVANCED_SEARCH_TEXT = "Advanced";
    static PLACEHOLDER_TEXT = "Please select an option"; // Dropdown place holder used dropdowns
    static NO_FILTER_RESULTS = "Filter yielded no results"; // Shows when no results from a search in the table
    static VIEW_ON_MAP_TEXT = "View on map";
    static CREATE_APPLICATION_TEXT = "Create application";
    static OPEN_APPLICATION_TEXT = "Open";
    static CONTINUE_STEP_TEXT = "Continue";
    static BACK_STEP_TEXT = "Back";
    static NEXT_STEP_TEXT = "Next";
    static SAVE_STEP_TEXT = "Save";
    static VIEW_APPLICATION_TEXT = "View application";
    static NEXT_STEPS_LABEL_TEXT = "Next steps";
    static UNKNOWN_ORGANISATION = "Unknown organisation";
    static PROPERTY_SEARCH_STATUS = "PropertySearch";
    static APPLICATION_SEARCH_STATUS = "ApplicationSearch";
    static ARCGIS_COLUMN_ID = "OBJECTID";
    static CLASS_REQUIRED_TEXT = "text-danger";
    static REQUIRED_TEXT_INDICATOR = "*";
    static INPUT_TYPE_TEXT = "text" /* CalciteInputTypeEnum.text */;
    static INPUT_TYPE_TEXTAREA = "textarea" /* CalciteInputTypeEnum.textarea */;
    static CLASS_DESCRIPTION_TEXT = "description-text";
    // Decimal values properties
    static CURRENCY_SYMBOL = "R";
    static DECIMAL_PLACES = 2;
    static NO_APPLICATION_LAYER = "No application layer has been set up for this module: Map searches are not allowed";
    static EXPORT_LABEL = "Export";
    static EXPORT_FILENAME_PLACEHOLDER_TEXT = "ExportValues";
    static ENTER_FILENAME_LABEL = "Enter filename";
    static DEFAULT_COUNTRY = "South Africa";
    static PROVINCE = [
        "Eastern Cape",
        "Free State",
        "Gauteng",
        "KwaZulu-Natal",
        "Limpopo",
        "Mpumalanga",
        "North West",
        "Northern Cape",
        "Western Cape",
    ];
    static COUNTRIES = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia & Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Islands",
        "Costa Rica",
        "Cote D Ivoire",
        "Croatia",
        "Cruise Ship",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Polynesia",
        "French West Indies",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kuwait",
        "Kyrgyz Republic",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Pakistan",
        "Palestine",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Pierre & Miquelon",
        "Samoa",
        "San Marino",
        "Satellite",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "St Kitts & Nevis",
        "St Lucia",
        "St Vincent",
        "St. Lucia",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor L\"Este",
        "Togo",
        "Tonga",
        "Trinidad & Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks & Caicos",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Virgin Islands (US)",
        "Yemen",
        "Zambia",
        "Zimbabwe",
    ];
    static MODAL_SIZE = {
        large: "lg",
        small: "sm",
        extraLarge: "xl"
    };
    static ROLES_ENUM = {
        Admin: "Admin",
        Login: "Login",
        User: "User",
    };
    static YES_NO_ENUM = {
        Yes: "Yes",
        No: "No",
    };
    static SYSTEM_ROLES_ENUM = {
        SuperAdmin: "Super Admin",
        OrganisationAdmin: "Organisation Admin",
        User: "User",
    };
    static FIELD_TYPE = {
        NumberType: "Number",
        StringType: "Text",
        DateType: "Date",
        Decimal: "Decimal",
        Dropdown: "Dropdown"
    };
    static TABLE_COLUMN_MAPPING_EXISTS_ERROR = "No column-to-item property mapping exists for table";
    static INVALID_TABLE_VALUE_ERROR = "Invalid table value exists";
    static SYSTEM_DATE_FORMAT_DEFAULT = "yyyy/MM/dd";
    static SERVER_MESSAGE_LISTENER_EVENT = "Notify";
    static SEND_SERVER_MESSAGE_ACTION = "";
    static SERVER_HUB_CONNECTION_ERROR_MESSAGE = "Error while establishing connection: ";
    static PERMISSION_NOT_GRANTED_FOR_NOTIFICATIONS_ERROR = "Permission not granted for web notifications";
    static NO_NOTIFICATION_BROWSER_SUPPORT_ERROR = "Browser does not support web notifications";
    static DAYS_LIMIT = 5;
    // Note constants
    static ADD_NOTE_PLACEHOLDER = "Start typing a new note...";
    static NOTE_CHARACTER_LIMIT = 500;
    // labels for internal fields
    static CREATED_USER_LABEL = "Created User";
    static CREATED_DATE_LABEL = "Created Date";
    static LAST_EDITED_USER_LABEL = "Last Edited User";
    static LAST_EDITED_DATE_LABEL = "Last Edited Date";
    static OBJECT_ID = "Object ID";
    static GLOBAL_ID = "Global ID";
    static MODULE_ID = "Module ID";
    static JOB_ID = "Job ID";
    // List of fields that can be hidden
    static SYSTEM_FIELD_LIST = ["objectid", "globalid", "rowid", "parentrowid", "jobid", "moduleid", "uniquerowid", "id", "deleted"];
    // List of labels for Recipient fields
    static RECIPIENT_FIELDLIST = {
        id: "Application Ref No",
        name: "Name",
        surname: "Surname",
        idNumber: "ID Number",
        organisation: "Organisation",
        designation: "Designation",
        telephone: "Telephone",
        homePhone: "Home phone",
        cellphone: "Cellphone",
        fax: "Fax",
        email: "Email",
        streetAddress: "Street Address",
        streetSuburb: "Street Address Suburb",
        streetCity: "Street Address City",
        streetProvince: "Street Address Province",
        streetCode: "Street Address Code",
        postalAddress: "Postal Address",
        postalSuburb: "Postal Address Suburb",
        postalCity: "Postal Address City",
        postalProvince: "Postal Address Province",
        postalCode: "Postal Address Code",
        professionalBody: "Professional Body",
        professionalBodyRegNum: "Professional Body Reg. No.",
        postalCountry: "Postal Address Country",
        streetCountry: "Street Address Country",
        representative: "Representative",
        organisationRegistrationNumber: "Organisation Registration Number"
    };
    // combine address into single label
    // @ts-ignore
    static ADDRESS_JOINED = "{address}, {suburb}, {city}, {code}, {province}, {country}";
    static INVOICE_DETAILS_LABEL = "Invoice details";
    // Constant used for keeping the main busy indicator from showing
    static NOT_BUSY_INDICATOR = "-DO-NOT-SHOW-BUSY-INDICATOR-";
    // Commonly used Lookup names
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static ZONING_LOOKUP_NAME = "Zoning";
}
